module.exports = __webpack_public_path__ + "img/tv-icon.76d1a85f.svg";